<template>
  <div class="mobile-filter-panel" :class="{ 'filters-collapsed': !expanded }">
    <button type="button" class="mobile-filter-toggle" :aria-expanded="expanded" :aria-controls="panelId" @click="expanded = !expanded">
      <span><a-icon type="filter" /> {{ label('filters') }} <small v-if="active">{{ label('filtered') }}</small></span>
      <a-icon :type="expanded ? 'up' : 'down'" />
    </button>
    <div :id="panelId" class="mobile-filter-body"><slot /></div>
  </div>
</template>
<script>
import { mobileUiText } from '@/utils/admin-mobile'
let nextId = 0
export default {
  name: 'AdminFilters',
  props: { active: Boolean },
  data() { return { expanded: false, panelId: `admin-filters-${++nextId}` } },
  methods: { label(key) { return mobileUiText(this.$adminLocale, key) } }
}
</script>
